import { render, staticRenderFns } from "./UpdateStudentGroupOrderNo.vue?vue&type=template&id=2a674faf&scoped=true"
import script from "./UpdateStudentGroupOrderNo.vue?vue&type=script&lang=js"
export * from "./UpdateStudentGroupOrderNo.vue?vue&type=script&lang=js"
import style0 from "./UpdateStudentGroupOrderNo.vue?vue&type=style&index=0&id=2a674faf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a674faf",
  null
  
)

export default component.exports